import { BaseForPlanHelper } from 'wizards/models/base/base-models/base-for-plan-helper';

export class BaseForVMPlanHelper extends BaseForPlanHelper {
  static clearAppAwareData(newPlan: unknown & { AppAwareGuestVmIndividualSettings: unknown }): void {
    delete newPlan.AppAwareGuestVmIndividualSettings;
  }
}
